"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Rating_1 = __importDefault(require("./Rating/Rating"));
var Table_1 = __importDefault(require("./Table/Table"));
var styled_components_1 = __importDefault(require("styled-components"));
var App_1 = require("./App/App");
var Icon_1 = __importDefault(require("./Icon/Icon"));
var Common_styled_1 = require("../Common.styled");
var react_break_1 = require("react-break");
var StyledTableWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-size: 0.8em;\n"], ["\n\tfont-size: 0.8em;\n"])));
var StyledRating = styled_components_1.default(Rating_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\n\t> svg {\n\t\twidth: 15px;\n\t\theight: 15px;\n\t}\n"], ["\n\tdisplay: inline-block;\n\n\t> svg {\n\t\twidth: 15px;\n\t\theight: 15px;\n\t}\n"])));
var StyledUL = styled_components_1.default.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tpadding: 0;\n\tmargin: 0;\n"], ["\n\tpadding: 0;\n\tmargin: 0;\n"])));
var Leaderboard = function () {
    var global = react_1.useContext(App_1.GlobalContext);
    var layout = react_break_1.layoutGenerator({
        mobile: 0,
        desktop: 900,
    });
    var OnMobile = layout.is('mobile');
    var OnDesktop = layout.is('desktop');
    var columns = react_1.useMemo(function () {
        var common = [
            {
                Header: 'Rank',
                accessor: 'position',
                disableFilters: true,
            },
            {
                Header: 'Name',
                accessor: 'nickname',
                disableFilters: true,
            },
            {
                Header: 'Belt',
                accessor: 'rank',
                disableFilters: true,
                Cell: function (_a) {
                    var row = _a.row;
                    var belt = global.belts.find(function (obj) { return obj.id === row.values.rank; });
                    var image = belt === null || belt === void 0 ? void 0 : belt.image.split('.');
                    if (image && belt) {
                        return (react_1.default.createElement(Common_styled_1.StyledRank, null,
                            react_1.default.createElement("div", { className: "svg-wrapper" },
                                react_1.default.createElement(Icon_1.default, { name: image[0], width: 30 })),
                            react_1.default.createElement(OnDesktop, null,
                                react_1.default.createElement("span", null, belt.title))));
                    }
                    return react_1.default.createElement(react_1.default.Fragment, null, "No rank");
                },
                filter: function (rows, id, filterValue) {
                    return rows.filter(function (row) {
                        var rowValue = row.values[id];
                        return filterValue[rowValue];
                    });
                },
            },
            {
                Header: function () { return react_1.default.createElement("div", { style: { textAlign: 'center' } }, "Stars"); },
                accessor: 'total_stars',
                disableFilters: true,
                Cell: function (_a) {
                    var row = _a.row;
                    return react_1.default.createElement("div", { style: { textAlign: 'center' } }, row.values.total_stars);
                },
            },
        ];
        var mobile = [
            {
                // @ts-ignore
                Header: function () { return null; },
                // @ts-ignore
                id: 'expander',
                Cell: function (_a) {
                    var row = _a.row;
                    return (react_1.default.createElement("span", __assign({}, row.getToggleRowExpandedProps(), { style: { fontSize: '2em', cursor: 'pointer' } }), row.isExpanded ? '-' : '+'));
                },
            },
        ];
        var desktop = [
            {
                Header: 'Region',
                accessor: 'region',
                disableFilters: true,
                Cell: function (_a) {
                    var row = _a.row;
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        row.original.state,
                        ", ",
                        row.original.country));
                },
            },
            {
                Header: 'Affiliate',
                accessor: 'affiliate',
                disableFilters: true,
                Cell: function (_a) {
                    var row = _a.row;
                    if (row.values.affiliate === '') {
                        return react_1.default.createElement(react_1.default.Fragment, null, "-");
                    }
                    return react_1.default.createElement(react_1.default.Fragment, null, row.values.affiliate);
                },
            },
            {
                Header: function () {
                    return react_1.default.createElement(StyledRating, { value: 3, type: "star", showUnfilled: false });
                },
                accessor: 'stars_3',
                disableFilters: true,
            },
            {
                Header: function () {
                    return react_1.default.createElement(StyledRating, { value: 3.5, type: "star", showUnfilled: false });
                },
                accessor: 'stars_3half',
                disableFilters: true,
            },
            {
                Header: function () {
                    return react_1.default.createElement(StyledRating, { value: 4, type: "star", showUnfilled: false });
                },
                accessor: 'stars_4',
                disableFilters: true,
            },
            {
                Header: function () {
                    return react_1.default.createElement(StyledRating, { value: 4.5, type: "star", showUnfilled: false });
                },
                accessor: 'stars_4half',
                disableFilters: true,
            },
            {
                Header: function () {
                    return react_1.default.createElement(StyledRating, { value: 5, type: "star", showUnfilled: false });
                },
                accessor: 'stars_5',
                disableFilters: true,
            },
        ];
        return {
            mobile: mobile.concat(common),
            desktop: common.concat(desktop),
        };
    }, [global]);
    var renderSubComponent = function (_a) {
        var row = _a.row;
        return (react_1.default.createElement("tr", null,
            react_1.default.createElement("td", null),
            react_1.default.createElement("td", { colSpan: 4 },
                react_1.default.createElement(StyledUL, null,
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("strong", null, "Region"),
                        ": ",
                        row.original.state,
                        ", ",
                        row.original.country),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("strong", null, "Affiliate"),
                        ": ",
                        row.values.affiliate ? row.values.affiliate : '-'),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(StyledRating, { value: 3, type: "star", showUnfilled: true }),
                        ": ",
                        row.original.stars_3),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(StyledRating, { value: 3.5, type: "star", showUnfilled: true }),
                        ": ",
                        row.original.stars_3half),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(StyledRating, { value: 4, type: "star", showUnfilled: true }),
                        ": ",
                        row.original.stars_4),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(StyledRating, { value: 4.5, type: "star", showUnfilled: true }),
                        ": ",
                        row.original.stars_4half),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(StyledRating, { value: 5, type: "star", showUnfilled: true }),
                        ": ",
                        row.original.stars_5)))));
    };
    return (react_1.default.createElement(StyledTableWrapper, null,
        react_1.default.createElement(OnMobile, null,
            react_1.default.createElement(Table_1.default, { columns: columns.mobile, data: global.students, renderRowSubComponent: renderSubComponent })),
        react_1.default.createElement(OnDesktop, null,
            react_1.default.createElement(Table_1.default, { columns: columns.desktop, data: global.students }))));
};
exports.default = Leaderboard;
var templateObject_1, templateObject_2, templateObject_3;
